import { html } from "lit";
import { formatHtml } from "@trumpf/ux.common-storybook";

export default {
    title: "Components/Price Box",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    component: "ux-iws-price-box",
    args: {
        breakpointDesktop: "1440",
    },
    argTypes: {
        breakpointDesktop: {
            control: "number",
        },
    },
};

const PriceBoxTemplate = ({ breakpointDesktop }) => html`
    <ux-iws-price-box breakpoint-desktop="${breakpointDesktop} ">
        <div class="ux-iws-price-box__container ux-u-mb-xxxs">
            <div class="ux-u-mb-xxs ux-row">
                <div class="ux-iws-price-box__sum ux-col-12">
                    <div class="ux-iws-price-box__sum--label">Subtotal</div>
                    <div class="ux-iws-price-box__sum--amount">635,71 €</div>
                </div>
            </div>
            <div class="ux-row">
                <div class="ux-u-mb-xxxs ux-col-12 ux-col-md-6">
                    <a
                        class="ux-button--full-width ux-button ux-button--green"
                        href="#"
                        id="add-to-cart"
                    >
                        <span>Add to cart</span>
                    </a>
                </div>
                <div class="ux-col-12 ux-col-md-6">
                    <a
                        class="ux-button--full-width ux-button ux-button--white"
                        href="#"
                        id="add-selection-to-cart"
                    >
                        <span>Add selection to cart</span>
                    </a>
                </div>
            </div>
        </div>
        <div class="ux-iws-price-box__container">
            <div class="ux-row">
                <div class="ux-col-12 ux-col-md">
                    <a
                        class="btn-fullWidth ux-u-mb-xxxs ux-button ux-button--white"
                        rel="modal:open"
                        href="#"
                        id="edit-wishlist"
                    >
                        <span>Edit Wishlist</span>
                    </a>
                </div>

                <div class="ux-col-12 ux-col-md">
                    <a
                        class="btn-fullWidth ux-u-mb-xxxs ux-button ux-button--white"
                        rel="modal:open"
                        href="#"
                        id="print-wishlist"
                    >
                        <span>Print Wishlist</span>
                    </a>
                </div>
                <div class="ux-col-12 ux-col-md">
                    <a
                        class="btn-fullWidth ux-u-mb-xxxs ux-button ux-button--white"
                        rel="modal:open"
                        href="#"
                        id="delete-wishlist"
                    >
                        <span>Delete Wishlist</span>
                    </a>
                </div>
            </div>
        </div>
    </ux-iws-price-box>
`;

export const Default = PriceBoxTemplate.bind({});
Default.args = { breakpointDesktop: "1440" };
